import { FC } from 'react';

type Props = {
	className?: string;
};

const OwnInnIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='none'
			className={className}>
			<path
				d='M16.1639 13.614C15.9323 10.4352 15.0806 8.08317 13.6689 6.30913V4.07715C16.227 4.91955 17.9743 9.9997 16.1639 13.614Z'
				fill='url(#paint0_linear_4863_6543)'
				stroke="none"
			/>
			<path
				d='M3.8364 6.38544C4.06797 9.56428 4.91964 11.9163 6.33133 13.6903L6.33133 15.9223C3.77325 15.0799 2.02594 9.99974 3.8364 6.38544Z'
				fill='url(#paint1_linear_4863_6543)'
				stroke="none"
			/>
			<path
				d='M19.9999 9.99982C19.9999 14.2082 17.4003 17.8096 13.7191 19.2857C13.695 19.2953 13.6686 19.2774 13.6686 19.2514V6.30925C15.2611 7.84766 16.2633 9.98894 16.3122 12.3563C16.3131 12.4036 16.3811 12.4097 16.391 12.3634C17.0616 9.22488 15.9324 6.08948 13.6686 4.07726C12.6675 3.18715 11.4442 2.51712 10.0561 2.16332C9.21736 1.94963 8.37563 1.86598 7.55282 1.90042C7.50113 1.90259 7.45801 1.86171 7.45801 1.80997V0.39662C7.45801 0.35507 7.4861 0.318567 7.52636 0.308314C8.31746 0.106864 9.14578 0 9.99971 0C11.2949 0 12.5327 0.246111 13.6686 0.694242C17.3765 2.15753 19.9999 5.77221 19.9999 9.99982Z'
				fill='url(#paint2_linear_4863_6543)'
				stroke="none"
			/>
			<path
				d='M12.5419 18.1896V19.6029C12.5419 19.6445 12.5138 19.681 12.4735 19.6912C11.6824 19.8927 10.8541 19.9995 10.0002 19.9995C8.70494 19.9995 7.46716 19.7534 6.33129 19.3053C2.62336 17.842 0 14.2273 0 9.99971C0 5.79133 2.59956 2.18996 6.28077 0.71387C6.3049 0.704199 6.33129 0.722126 6.33129 0.74812V13.6903C4.73874 12.1519 3.73655 10.0106 3.68772 7.64326C3.68674 7.59596 3.61876 7.58986 3.60887 7.63613C2.93828 10.7747 4.06746 13.9101 6.33129 15.9223C7.33236 16.8124 8.55569 17.4824 9.9438 17.8362C10.7825 18.0499 11.6243 18.1336 12.4471 18.0991C12.4988 18.097 12.5419 18.1378 12.5419 18.1896Z'
				fill='url(#paint3_linear_4863_6543)'
				stroke="none"
			/>
			<defs>
				<linearGradient
					id='paint0_linear_4863_6543'
					x1='15.2887'
					y1='0.0820825'
					x2='15.2887'
					y2='19.7605'
					gradientUnits='userSpaceOnUse'>
					<stop
						offset='0.156425'
						stopColor='#4B4B4B'
					/>
					<stop
						offset='1'
						stopColor='#2B2B2B'
					/>
				</linearGradient>
				<linearGradient
					id='paint1_linear_4863_6543'
					x1='4.71156'
					y1='0.0821225'
					x2='4.71156'
					y2='19.7606'
					gradientUnits='userSpaceOnUse'>
					<stop
						offset='0.156425'
						stopColor='#4B4B4B'
					/>
					<stop
						offset='1'
						stopColor='#2B2B2B'
					/>
				</linearGradient>
				<linearGradient
					id='paint2_linear_4863_6543'
					x1='13.7289'
					y1='-0.0465709'
					x2='13.7289'
					y2='19.5159'
					gradientUnits='userSpaceOnUse'>
					<stop
						offset='0.106145'
						stopColor='#818181'
					/>
					<stop
						offset='0.37144'
						stopColor='#6D6D6D'
					/>
					<stop
						offset='0.756831'
						stopColor='#565656'
					/>
					<stop
						offset='1'
						stopColor='#4E4E4E'
					/>
				</linearGradient>
				<linearGradient
					id='paint3_linear_4863_6543'
					x1='6.27094'
					y1='-0.0466752'
					x2='6.27094'
					y2='19.5158'
					gradientUnits='userSpaceOnUse'>
					<stop
						offset='0.106145'
						stopColor='#818181'
					/>
					<stop
						offset='0.37144'
						stopColor='#6D6D6D'
					/>
					<stop
						offset='0.756831'
						stopColor='#565656'
					/>
					<stop
						offset='1'
						stopColor='#4E4E4E'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default OwnInnIcon;
